import type { SlideImage } from "yet-another-react-lightbox";
export function Gallery2014(){


  const slides: SlideImage[] = [
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_001.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_001.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_002.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_002.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_003.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_003.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_004.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_004.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_005.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_005.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_006.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_006.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_007.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_007.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_008.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_008.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_009.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_009.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_010.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_010.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_011.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_011.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_012.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_012.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_013.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_013.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_014.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_014.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_015.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_015.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_016.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_016.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_017.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_017.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_018.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_018.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_019.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_019.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_020.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_020.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_021.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_021.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_022.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_022.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_023.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_023.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_024.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_024.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_025.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_025.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_026.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_026.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_027.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_027.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_028.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_028.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_029.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_029.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_030.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_030.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_031.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_031.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_032.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_032.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_033.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_033.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_034.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_034.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_035.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_035.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_036.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_036.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_037.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_037.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_038.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_038.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_039.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_039.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2014/IMG_040.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2014/SML_040.jpg"
        }   
     ];

     return slides;
} 
